import { Link } from 'react-router-dom'
import { useUsuario } from '../hooks/useUsuario'
import { clientesFeria, clientesRedes } from '../modelos/cliente'

export default function Contador({ fromRedes = false, className = '', onClick }) {
    const { usuario } = useUsuario()
    const totalParticipaciones = fromRedes ? clientesRedes.length : clientesFeria.length + 1
    const numParticipaciones = fromRedes
        ? usuario?.numParticipacionesRedes || 0
        : usuario?.numParticipaciones || 0

    return (
        <Link
            onClick={onClick}
            to="/progreso"
            className={`bg-[#D02D38] py-2 px-4 text-white flex justify-center items-center gap-4 rounded-full max-w-sm mx-auto ${className}`}>
            <p className="text-white font-semibold m-0 py-0 inline-block text-balance">
                Tu pasaporte del Sabor
            </p>
            <p className="rounded-full border border-white px-4 py-1 m-0 font-normal">
                {String(numParticipaciones).padStart(2, '0')}/{totalParticipaciones}
            </p>
        </Link>
    )
}
